<script>
    import { createEventDispatcher } from "svelte";
    import Form from "./Form.svelte";
    import { HStack, VStack, Spacer } from "../component/layout";
    import { Padding } from "../component/modifier";
    import { Button, Label, Icon, Text, Choice, Hamburger, TextArea } from "./widget";
    import { create } from "../rsvp.js";
    import { trim, capitalize, uppercase } from "../utils.js";
    import { AGE_LABEL } from "../dico.js";
    import MediaQuery from "./layout/MediaQuery.svelte";

    export let wedding_guid;
    export let hasTampon = false;
    export let isBapteme;

    const dispatch = createEventDispatcher();

    let step = 1;
    let steps = [];

    function updateSteps(isPresent) {
        //if (isPresent) {
            steps = [
                {
                    id: 1,
                    name: "Présence",
                    done: false,
                    back: false,
                    cancel: true,
                    submit: "continue",
                    next: 2,
                    prev: null,
                },
                {
                    id: 2,
                    name: "Dîner",
                    done: false,
                    back: true,
                    cancel: true,
                    submit: "continue",
                    next: 3,
                    prev: 1,
                },
                {
                    id: 3,
                    name: "Confirmation",
                    done: false,
                    back: true,
                    cancel: true,
                    submit: "validate",
                    next: 4,
                    prev: 2,
                },
                {
                    id: 4,
                    name: "Félicitations",
                    done: false,
                    back: false,
                    cancel: false,
                    submit: "final",
                    next: null,
                    prev: 3,
                },
            ];
       /*  } else {
            steps = [
                {
                    id: 1,
                    name: "Présence",
                    done: false,
                    back: false,
                    cancel: true,
                    submit: "continue",
                    next: 3,
                    prev: null,
                },
                {
                    id: 2,
                    name: "Dîner",
                    done: false,
                    back: true,
                    cancel: true,
                    submit: "continue",
                    next: 3,
                    prev: 1,
                },
                {
                    id: 3,
                    name: "Confirmation",
                    done: false,
                    back: true,
                    cancel: true,
                    submit: "validate",
                    next: 4,
                    prev: 1,
                },
                {
                    id: 4,
                    name: "Félicitations",
                    done: false,
                    back: false,
                    cancel: false,
                    submit: "final",
                    next: null,
                    prev: 3,
                },
            ];
        } */
    }

    let form = undefined;

    let current = "";
    let attending = null;
    let attending_1 = null;
    let guests = [];
    let comment = null;

    let isAddGuest = false;

    let guestId = null;
    let firstname = null;
    let lastname = null;
    let age = "A";
    let age_val = null;
    let gender = "F";
    let food_restriction = null;
    let favorite_songs = null;
    let hamburgerOpened = [];
    hamburgerOpened[0] = false;
    let hasAttending1 = true;

    $: showAgeVal = age != "A";

    $: guestCount = guests.length;

    $: isPresent = attending == null || attending == "O";

    $: updateSteps(isPresent);

    const cancel = () => {
        isAddGuest = false;
    };

    const add = () => {
        isAddGuest = false;

        if (guestId !== null) {
            //console.log("modify person");
            let g = guests[guestId];
            g.firstname = firstname;
            g.lastname = lastname;
            g.age = age;
            g.gender = gender;
            g.food_restriction = food_restriction;
            g.favorite_songs = favorite_songs;
            g.age_val = age_val;
        } else {
            //console.log("add person", guestId);
            guests.push({
                firstname: capitalize(trim(firstname)),
                lastname: uppercase(trim(lastname)),
                age: age,
                gender: gender,
                food_restriction: trim(food_restriction),
                favorite_songs: trim(favorite_songs),
                hamburgerOpened: false,
                opened: false,
                age_val: age_val,
            });
        }
        guests = [...guests];
    };

    const addGuest = () => {
        firstname = null;
        lastname = null;
        age = "A";
        gender = "F";
        guestId = null;
        food_restriction = null;
        favorite_songs = null;
        isAddGuest = true;
        age_val = null;
    };

    const editGuest = (i) => {
        guestId = i;

        //console.log("edit", guestId);

        let g = guests[i];
        firstname = g.firstname;
        lastname = g.lastname;
        age = g.age;
        gender = g.gender;
        food_restriction = g.food_restriction;
        favorite_songs = g.favorite_songs;
        age_val = g.age_val;

        isAddGuest = true;
        g.hamburgerOpened = false;
    };

    const delGuest = (i) => {
        console.log("del", i);
        guests.splice(i, 1);
        guests = [...guests];
    };

    const submit = async () => {
        //console.log("submit", step);

        if (step == 1) {
        } else if (step == 2) {
            if (guests.length == 0) {
                let err = new Error("Veuillez renseigner au moins une personne");
                err.name = "Warning";
                throw err;
            }
        } else if (step == 3) {
            //console.log(attending, guests, comment);
            await create(wedding_guid, attending, attending_1, guests, comment);
        } else if (step == 4) {
            dispatch("close");
        }
    };

    function validate(event) {
        switch (event.target.name) {
            case "c1":
                break;
            default:
                break;
        }
    }
</script>

<Form
    bind:form
    bind:step
    bind:steps
    {submit}
    {validate}
    validateButton={"Confirmer"}
    backButton={"Retour"}
    showActions={!isAddGuest}
    on:close
    padding={false}>
    <article>
        {#if step == 1}
            <VStack>
                {#if hasTampon}
                    <HStack>
                        <Spacer />
                        {#if isBapteme}
                            <img alt="logo" height="200px" width="200px" src="/images/tampon_bapteme_RSVP.png" />
                        {:else}
                            <img alt="logo" height="100px" width="100px" src="/images/tampon4.png" />
                        {/if}
                        <Spacer />
                    </HStack>
                {/if}
                {#if isBapteme}
                    <p>Serez-vous présent au cokctail et dîner du baptême ?</p>
                {:else}
                    <p>Serez-vous présent à la soirée de mariage ?</p>
                {/if}
                <Padding>
                    <Choice
                        id={"attending"}
                        bind:value={attending}
                        bind:current
                        required
                        label="Présent"
                        icon="fas fa-glass-cheers"
                        values={[
                            { value: "O", label: "Oui" },
                            { value: "N", label: "Non" },
                        ]} />
                </Padding>
                {#if hasAttending1}
                    <p>Serez-vous présent au brunch ?</p>
                    <Padding>
                        <Choice
                            id={"attending_1"}
                            bind:value={attending_1}
                            bind:current
                            required
                            label="Présent"
                            icon="fas fa-glass-cheers"
                            values={[
                                { value: "O", label: "Oui" },
                                { value: "N", label: "Non" },
                            ]} />
                    </Padding>
                {/if}
            </VStack>
        {:else if step == 2}
            <VStack>
                {#if !isAddGuest && guestCount > 0}
                    <p>Seront présents au dîner :</p>
                    {#each guests as g, i}
                        <Button action={() => (g.opened = !g.opened)}>
                            <section class="member" class:opened={g.opened}>
                                <HStack alignment="flex-start" grow>
                                    <span class="name">
                                        {#if g.age == "A"}
                                            {#if g.gender == "F"}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={AGE_LABEL[g.age]}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="female"
                                                    iconColor="#FF005C" />
                                            {:else}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={AGE_LABEL[g.age]}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="male" />
                                            {/if}
                                        {:else if g.age == "T"}
                                            {#if g.gender == "F"}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    fa={false}
                                                    icon="images/cap_pink.svg"
                                                    iconColor="#FF005C" />
                                            {:else}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    fa={false}
                                                    icon="images/cap.svg" />
                                            {/if}
                                        {:else if g.age == "C"}
                                            {#if g.gender == "F"}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="child"
                                                    iconColor="#FF005C" />
                                            {:else}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="child" />
                                            {/if}
                                        {:else if g.age == "B"}
                                            {#if g.gender == "F"}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="baby"
                                                    iconColor="#FF005C" />
                                            {:else}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="baby" />
                                            {/if}
                                        {/if}
                                    </span>
                                    {#if !isBapteme}
                                        <MediaQuery query="(min-width: 481px)">
                                            {#if g.food_restriction}
                                                <span class="label">
                                                    <Icon
                                                        name="utensils"
                                                        tooltip={g.food_restriction} />
                                                </span>
                                            {/if}
                                            {#if g.favorite_songs}
                                                <span class="label">
                                                    <Icon name="music" tooltip={g.favorite_songs} />
                                                </span>
                                            {/if}
                                        </MediaQuery>
                                    {/if}
                                    <Spacer />
                                    <Hamburger bind:open={g.hamburgerOpened} left={false}>
                                        <Button action={() => editGuest(i)}>
                                            <Label text="Editer" noshrink icon="edit" h="24px" />
                                        </Button>
                                        <Button action={() => delGuest(i)}>
                                            <Label
                                                text="Supprimer"
                                                noshrink
                                                icon="times-circle"
                                                h="24px" />
                                        </Button>
                                    </Hamburger>
                                </HStack>
                                {#if !isBapteme}
                                    {#if g.opened}
                                        <VStack>
                                            <Label
                                                icon="utensils"
                                                noshrink
                                                text={g.food_restriction || "Aucune restriction"}
                                                h="unset" />
                                            <Label
                                                icon="music"
                                                noshrink
                                                text={g.favorite_songs || "Pas de chanson favorite"}
                                                h="unset" />
                                        </VStack>
                                    {/if}
                                {/if}
                            </section>
                        </Button>
                    {/each}
                    <p>
                        <Button action={addGuest}>
                            <Label text="Ajouter une personne" icon="user-plus" noshrink />
                        </Button>
                    </p>
                {:else}
                    <form
                        on:submit|preventDefault={add}
                        on:invalid={validate}
                        on:changed={validate}
                        on:input={validate}>
                        <Text
                            id={"firstname"}
                            reset
                            required
                            bind:value={firstname}
                            icon="fas fa-user"
                            label="Prénom"
                            placeholder="Prénom"
                            bind:current
                            textTransform={"capitalize"} />

                        <Text
                            id={"lastname"}
                            reset
                            required
                            bind:value={lastname}
                            icon="fas fa-user"
                            label="Nom"
                            placeholder="Nom"
                            bind:current
                            textTransform={"uppercase"} />

                        <!-- age -->
                        <Choice
                            id={"age"}
                            label="Age"
                            bind:value={age}
                            bind:current
                            icon="fas fa-user-clock"
                            values={[
                                { value: "A", label: "Adulte" },
                                { value: "T", label: "Ado" },
                                { value: "C", label: "Enfant" },
                                { value: "B", label: "Bébé" },
                            ]} />
                        {#if showAgeVal}
                            <Text
                                id={"age_val"}
                                type="number"
                                reset
                                required
                                bind:value={age_val}
                                icon="fas fa-user-clock"
                                label="Age"
                                placeholder="Age"
                                bind:current />
                        {/if}

                        <!-- gender -->
                        <Choice
                            id={"gender"}
                            bind:value={gender}
                            bind:current
                            label="Genre"
                            icon="fas fa-venus-mars"
                            values={[
                                { value: "F", label: "Femme" },
                                { value: "M", label: "Homme" },
                            ]} />

                        {#if !isBapteme}
                        <Text
                            id={"food_restriction"}
                            reset
                            bind:value={food_restriction}
                            icon="fas fa-utensils"
                            label="Restrictions"
                            placeholder="Restrictions alimentaires"
                            bind:current />

                        <Text
                            id={"favorite_songs"}
                            reset
                            bind:value={favorite_songs}
                            icon="fas fa-music"
                            label="Chansons"
                            placeholder="La chanson qui vous fera danser !"
                            bind:current />
                        {/if}
                        <HStack>
                            {#if guestCount > 0}
                                <button class="cancel" type="button" on:click={cancel}>
                                    <i class="fas fa-angle-double-up" />
                                    <span>Annuler</span>
                                </button>
                            {/if}
                            <button class="primary" type="submit">
                                <i class="fas fa-user-plus" />
                                {#if guestId !== null}
                                    <span>Modifier</span>
                                {:else}
                                    <span>Valider</span>
                                {/if}
                            </button>
                            <Spacer />
                        </HStack>
                    </form>
                {/if}
            </VStack>
        {:else if step == 3}
            <VStack>
                <p>Veuillez vérifier les informations avant de confirmer.</p>
                <p>
                    <HStack wrap>
                        {#if isBapteme}
                        <span>Présent au cocktail et dîner du baptême:</span>
                        {:else}
                        <span>Présent à la soirée de mariage:</span>
                        {/if}
                        <span class="label" class:attending={attending === "O"}>
                            <Label text={attending === "O" ? "OUI" : "NON"} noshrink />
                        </span>
                    </HStack>
                    {#if hasAttending1}
                        <HStack wrap>
                            <span>Présent au brunch:</span>
                            <span class="label" class:attending={attending === "O"}>
                                <Label text={attending_1 === "O" ? "OUI" : "NON"} noshrink />
                            </span>
                        </HStack>
                    {/if}
                    {#if attending == "O"}
                        Serons présents au dîner :
                        {#each guests as g, i}
                            <section class="">
                                <HStack alignment="flex-start" grow>
                                    <span class="name">
                                        {#if g.age == "A"}
                                            {#if g.gender == "F"}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={AGE_LABEL[g.age]}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="female"
                                                    iconColor="#FF005C" />
                                            {:else}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={AGE_LABEL[g.age]}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="male" />
                                            {/if}
                                        {:else if g.age == "T"}
                                            {#if g.gender == "F"}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    fa={false}
                                                    icon="images/cap_pink.svg"
                                                    iconColor="#FF005C" />
                                            {:else}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    fa={false}
                                                    icon="images/cap.svg" />
                                            {/if}
                                        {:else if g.age == "C"}
                                            {#if g.gender == "F"}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="child"
                                                    iconColor="#FF005C" />
                                            {:else}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="child" />
                                            {/if}
                                        {:else if g.age == "B"}
                                            {#if g.gender == "F"}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="baby"
                                                    iconColor="#FF005C" />
                                            {:else}
                                                <Label
                                                    text="{g.firstname}
                      {g.lastname}"
                                                    tooltip={`${AGE_LABEL[g.age]} (${
                                                        g.age_val
                                                    } ans)`}
                                                    nowrap
                                                    noshrink
                                                    size="18"
                                                    icon="baby" />
                                            {/if}
                                        {/if}
                                    </span>
                                    {#if !isBapteme}
                                        {#if g.food_restriction}
                                            <span class="label">
                                                <Icon name="utensils" tooltip={g.food_restriction} />
                                            </span>
                                        {/if}
                                        {#if g.favorite_songs}
                                            <span class="label">
                                                <Icon name="music" tooltip={g.favorite_songs} />
                                            </span>
                                        {/if}
                                    {/if}
                                    <Spacer />
                                </HStack>
                                {#if !isBapteme}
                                    {#if g.opened}
                                        <VStack>
                                            <Label
                                                icon="utensils"
                                                text={g.food_restriction || "Aucune restriction"}
                                                noshrink
                                                h="unset" />
                                            <Label
                                                icon="music"
                                                text={g.favorite_songs || "Pas de chanson favorite"}
                                                noshrink
                                                h="unset" />
                                        </VStack>
                                    {/if}
                                {/if}
                            </section>
                        {/each}
                    {/if}
                </p>
                {#if isBapteme}
                <TextArea
                    id={"comment"}
                    reset
                    bind:value={comment}
                    icon="fas fa-edit"
                    label="Commentaire"
                    placeholder="Un petit message pour Lucie ?"
                    bind:current />
                {:else}
                <TextArea
                    id={"comment"}
                    reset
                    bind:value={comment}
                    icon="fas fa-edit"
                    label="Commentaire"
                    rows=3
                    placeholder="Un petit message aux futurs mariés ?"
                    bind:current />
                    {/if}
            </VStack>
        {:else if step == 4}
            <VStack>
                <h1>Félicitations !</h1>
                <p>Votre RSVP a bien été validé.</p>
            </VStack>
        {/if}
    </article>
</Form>

<style>
    article {
        height: 480px;
        width: 480px;
        overflow: auto;
    }

    button.cancel {
        margin-right: 1em;
    }

    section.member {
        line-height: 3em;
        border: 1px solid var(--primary-color);
        border-radius: 5px;
        padding-top: 10px;
        padding-left: 5px;
        margin-bottom: 5px;
        height: auto;
    }

    section.member:nth-child(even) {
        background-color: #edf4f9;
    }

    span {
        margin-right: 1em;
    }
    span.name {
        line-height: 1em;
        border-radius: 15px;
        background-color: #b8c5d0;
        padding: 0.5em;
        margin-bottom: 5px;
        margin-right: 1em;
    }

    span.label {
        line-height: 1em;
        border-radius: 15px;
        background-color: #b8c5d0;
        padding: 0.5em;
        margin-bottom: 5px;
        margin-right: 1em;
    }

    span.label.attending {
        background-color: var(--primary-light-color);
        color: var(--on-primary-color);
    }

    @media screen and (max-height: 600px) {
        article {
            height: auto;
            min-height: 387px;
        }
    }
    @media screen and (max-width: 600px) {
        article {
            width: 100%;
            overflow-y: auto;
        }
    }

    h1 {
        font-family: "Cinzel";
        font-size: 1.5rem;
        text-align: center;
    }
</style>
